import { ValidationResult } from './validation-result';
import { FormControl } from '@angular/forms';

export class CPFValidator {

    static validaCPF(formCPF: FormControl): ValidationResult {
        const cpf = formCPF.value;
        if (cpf) {
            const exp = /\.|\-|\_/g;
            const strCPF = cpf.toString().replace(exp, '');

            if (strCPF.length < 11 || strCPF.length > 14) {
                return { 'cpfInvalido': true };
            }

            if (CPFValidator.isBlackListed(strCPF)) {
                return { 'cpfInvalido': true };
            }

            if (!CPFValidator.isValidBaseCPF(strCPF)) {
                return { 'cpfInvalido': true };
            }

            if (!CPFValidator.isValidDigito(strCPF)) {
                return { 'cpfInvalido': true };
            }
        }

        return null;
    }

    static isBlackListed(strCPF) {
        const blockCpf = ['00000000000',
                          '11111111111',
                          '22222222222',
                          '33333333333',
                          '44444444444',
                          '55555555555',
                          '66666666666',
                          '77777777777',
                          '88888888888',
                          '99999999999'];

        if (blockCpf.find(k => k === strCPF) !== undefined) {
            return true;
        }

        return false;
    }

    static isValidBaseCPF(strCPF) {
        let soma = 0;
        let resto;
        let i;

        for (i = 1; i <= 9; i++) {
            soma = soma + parseInt(strCPF.substring(i - 1, i), 10) * (11 - i);
        }

        resto = (soma * 10) % 11;

        if ((resto === 10) || (resto === 11))  {
            resto = 0;
        }

        if (+resto !== parseInt(strCPF.substring(9, 10), 10) ) {
            return false;
        }

        return true;
    }

    static isValidDigito(strCPF) {
        let soma = 0;
        let resto;
        let i;

        for (i = 1; i <= 10; i++) {
            soma = soma + parseInt(strCPF.substring(i - 1, i), 10) * (12 - i);
        }

        resto = (soma * 10) % 11;

        if ((+resto === 10) || (+resto === 11))  {
            resto = 0;
        }

        if (+resto !== parseInt(strCPF.substring(10, 11), 10) ) {
            return false;
        }

        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/validators/cpf-validator.ts